var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPointerSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7 6.32749L0.685509 0.0396058C0.330025 -0.10946 -0.0582011 0.184155 0.00728279 0.554562L2.70616 16.1568C2.77632 16.5679 3.32358 16.6989 3.58551 16.3646L7.10761 11.8475C7.30406 11.599 7.69229 11.5945 7.88874 11.8384L12.5802 17.6339C12.917 18.0495 13.5344 18.1218 13.9647 17.7965L14.7412 17.2093C15.1715 16.8841 15.2463 16.2878 14.9096 15.8722L10.1994 10.0541C9.99826 9.8057 10.0965 9.43981 10.4005 9.32236L15.6954 7.1993C16.0976 7.03668 16.1023 6.49011 15.7047 6.32297L15.7 6.32749Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointerSmall);
export default __webpack_public_path__ + "static/media/pointer-small.a2d9f90ae177851ac0147550d4274ed4.svg";
export { ForwardRef as ReactComponent };